module.exports = __webpack_public_path__ + "img/DE02742.c315f27a.png";